import { RoleEntityPermissionMap } from './entity-permission.model';
import { BaseModel } from '../base.model';
import { EntityApplications } from '../../lists/entity-applications.enum';
import { AssignmentTrigger } from '../../lists/assignment-trigger.enum';

export enum UserRoleModelKeys {
  role = 'role',
  activity = 'activity',
  isEnable = 'isEnable',
  appId = 'appId',
  assignmentTrigger = 'assignmentTrigger',
}

export class UserRole extends BaseModel {
  [UserRoleModelKeys.role]: string;
  [UserRoleModelKeys.appId]: EntityApplications;
  [UserRoleModelKeys.activity]: RoleEntityPermissionMap;
  [UserRoleModelKeys.isEnable]: boolean = true;
  [UserRoleModelKeys.assignmentTrigger]: AssignmentTrigger = AssignmentTrigger.defaultTrigger;

  constructor(appId?: EntityApplications) {
    super();

    this[UserRoleModelKeys.appId] = appId;
  }
}
